const convertToStructure = require('./src/convertToStructure')
const { fountainToProse } = require('./src/fountainToProse')
const deltaToFountain = require('./src/deltaToFountain')
const scriptToFDX = require('./src/scriptToFDX')
const structureToHTML = require('./src/structureToHTML')
const fdxToScript = require('./src/fdxToScript')
const { fountainRegex } = require('./src/regex')

const converter = {
  toFountain: function (delta) {
    return deltaToFountain(delta)
  },
  toFDX: function (content) {
    if (typeof content === 'object') {
      content = deltaToFountain(content)
    }
    const struct = convertToStructure(content)
    return scriptToFDX(struct, 'STRUCTURE_TO_FDX')
  },
  toHTML: function (content, print, title) {
    // is it a delta?
    if (typeof content === 'object' && !Array.isArray(content)) {
      content = deltaToFountain(content)
    }
    // is it already in struct format?
    const struct = !Array.isArray(content) ? convertToStructure(content) : content
    return structureToHTML(struct, print, title)
  },
  toStructure: function (content) {
    if (typeof content === 'object') {
      content = deltaToFountain(content)
    }
    return convertToStructure(content)
  },
  fountainToProse,
  fdxToFountain: (content, callback) => fdxToScript(content, 'FDX_TO_FOUNTAIN', callback),
  fountainRegex,
  proseToFDX: content => scriptToFDX(content, 'PROSE_TO_FDX'),
  fdxToProse: (content, callback) => fdxToScript(content, 'FDX_TO_PROSE', callback)
}

module.exports = converter
